
import { Component, Vue } from "vue-property-decorator";
import { isMaintenanceMode } from "@/utils/methods";

const LOGIN_ROUTE = "Login";

@Component
export default class Error503 extends Vue {
  mounted() {
    if (!isMaintenanceMode()) this.$router.push({ name: LOGIN_ROUTE });
  }
}
